import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import wygImg2 from '../assets/public-site/empAward.svg';
import introImg from '../assets/public-site/EmployeepageIntro.jpg';
import wygImg1 from '../assets/public-site/empStar.svg';
import wygImg4 from '../assets/public-site/empSystem.svg';
import wygImg3 from '../assets/public-site/empTime.svg';
import forEmp from '../assets/public-site/forEmp.png';
import connectingLine from '../assets/public-site/hiw-connectingLine.svg';
import image16 from '../assets/public-site/img16.jpeg';
import image4 from '../assets/public-site/img4.png';
import { ReactComponent as SurfaceIcon } from '../assets/public-site/svg15.svg';
import { ReactComponent as MatchIcon } from '../assets/public-site/svg16.svg';
import { ReactComponent as PlaceIcon } from '../assets/public-site/svg17.svg';
import { TestimonialCarousel } from '../components/common/TestimonialCarousel';
import { TrustedBrands } from '../components/common/TrustedBrands';
import { VovationalPage } from '../components/common/VovationalPage';
import { ExportedIcon } from '../components/icons/icons';
import { NewFooter } from '../components/Layout/NewFooter';
import { NewNavbar } from '../components/Layout/NewHeader';

import { ConnectForm } from './ConnectUseForm';

export const EmployeePage: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  const testimonialData = [
    {
      name: 'Edwin Rivera',
      location: 'Managing Partner,CG1 Solutions',
      title: 'Faster Hires, Better Matches',
      text: 'Vero completely changed how we hire. Time-to-fill dropped, and our best performers now come from overlooked pools.',
      image: image16,
      collanColor: 'text-[#4A5FF7]',
    },
  ];

  const getCard = [
    {
      Image: wygImg1,
      title: 'Surface overlooked talent',
      description:
        'Discover candidates your current tools miss-based on skills, motivation, and long-term potential not resumes.',
    },
    {
      Image: wygImg2,
      title: 'Predict top performers early',
      description:
        'Go beyond screening. Vero identifies who is likely to succeed and stay, using real hiring and retention outcomes.',
    },
    {
      Image: wygImg3,
      title: 'Cut time-to-hire by up to 60%',
      description:
        'Match faster, reduce recruiter load, and scale talent pipelines without compromising fit.',
    },
    {
      Image: wygImg4,
      title: 'Integrate with your systems',
      description: 'Vero works across your ATS, HRIS, CRM, and job platforms. No rip-and-replace.',
    },
  ];

  const comparisonData = [
    {
      category: 'Data Source',
      mostHiringTools: 'Resumes, test scores',
      veroLearning: 'Skills, behavior, motivation, retention outcomes',
    },
    {
      category: 'Talent Pool',
      mostHiringTools: 'Traditional candidates',
      veroLearning: 'Overlooked and nontraditional talent',
    },
    {
      category: 'Matching Logic',
      mostHiringTools: 'Keywords and past roles',
      veroLearning: 'Predictive trajectory + fit over time',
    },
    {
      category: 'Workflow',
      mostHiringTools: 'Screen and sort',
      veroLearning: 'Surface, match, track, improve',
    },
    {
      category: 'Systems Fit',
      mostHiringTools: 'Standalone or rip-and-replace',
      veroLearning: 'Integrates across your ATS, CRM, and HR tools',
    },
    {
      category: 'Long-Term View',
      mostHiringTools: 'Placement only',
      veroLearning: 'Placement, performance, and upward mobility',
    },
  ];

  return (
    <div>
      {/* header */}
      <NewNavbar />

      {/* hero section */}
      <section
        className="
    relative w-full h-screen bg-cover bg-center bg-no-repeat 
    before:absolute before:inset-0 before:z-10 
    lg:before:hidden
    before:bg-gradient-to-r before:from-black before:to-transparent
  "
        style={{
          backgroundImage: `
      linear-gradient(180deg, rgba(0, 0, 0, 0) 47.64%, #000000 100%),
      url(${introImg})
    `,
        }}
      >
        <div className="relative z-20 flex items-end justify-center h-full container mx-auto px-6 pb-10 text-white text-center">
          <div className="w-full space-y-6">
            <h1 className="text-4xl text-[#FFFFFF] sm:text-5xl">
              Smarter hiring. <span className="text-[#FFC90D] font-bold">Stronger retention. </span>{' '}
              Predictive fit.
            </h1>
            <p className="mt-2 text-[#FFFFFF] text-lg sm:text-xl !leading-normal">
              Vero is the workforce intelligence infrastructure for employers who don’t just want to
              fill roles—they want to predict long-term success.
              <br />
              <br />
              Surface overlooked talent. Predict top performers. Cut hiring delays by up to 60%. All
              without disrupting your existing systems.
            </p>

            <a
              href="https://meetings.hubspot.com/chrissybil/vero-learning"
              className="btn btn-primary !px-9 !py-6 hover:underline rounded-md inline-flex items-center gap-2"
              target="_blank"
              rel="noopener noreferrer"
            >
              Schedule a strategy session <ExportedIcon />
            </a>
          </div>
        </div>
      </section>

      {/* What’s at Stake Section */}
      <section className="py-16">
        <div className="container px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
            {/* Left Content */}
            <div>
              <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-light mb-4 !leading-tight">
                What’s at
                <span className="font-bold text-primary-500"> Stake</span>
              </h2>

              <p className="text-base sm:text-lg md:text-xl leading-relaxed">
                Hiring frontline talent shouldn’t feel like a gamble-but it often does.
              </p>

              <p className="text-base sm:text-lg md:text-xl font-semibold leading-relaxed mt-4">
                Without predictive insight, employers are stuck guessing:
              </p>

              <ul className="list-disc pl-5 text-base sm:text-lg md:text-xl !leading-loose mt-2">
                <li>Who’s likely to show up—and stay</li>
                <li>Which candidates will succeed long term</li>
                <li>Where internal mobility can fill staffing gaps</li>
                <li>What roles new hires can grow into</li>
                <li>How to reduce churn without over-hiring</li>
              </ul>

              <p className="text-base sm:text-lg md:text-xl leading-loose mt-4 mb-6">
                The cost? Wasted training, avoidable no-shows, burnt-out managers, and constant
                re-hiring.
                <br />
                <br />
                Vero replaces guesswork with evidence-before day one. See how predictive matching
                changes the equation.
              </p>
              <a
                className="btn btn-secondary !px-6 !py-6 hover:underline inline-flex items-center gap-2"
                href="https://meetings.hubspot.com/chrissybil/vero-learning"
                target="_blank"
              >
                Surface overlooked talent now <ExportedIcon />
              </a>
            </div>

            {/* Right Image */}
            <div className="relative w-full">
              <img
                src={image4}
                alt="Team Collaboration"
                className="w-full h-auto object-cover rounded-xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* What You Get Section */}
      <section className="py-16 bg-primary-200">
        <div className="container px-4">
          <h2 className="text-4xl sm:text-5xl md:text-6xl font-light mb-4 !leading-tight text-center">
            What You
            <span className="font-bold text-primary-500"> Get</span>
          </h2>

          {/* Job Second Cards */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-6 cursor-pointer">
            {getCard.map((card, idx) => (
              <div
                key={idx}
                className="bg-white rounded-[40px] overflow-hidden relative p-8 border border-purple-200 shadow-lg hover:shadow-xl transition-all"
              >
                {card.Image && <img src={card.Image} alt={card.title} className="h-56 mx-auto" />}
                <div className="mt-5">
                  <p className="text-3xl text-center font-bold">{card.title}</p>

                  <p
                    className={`text-center text-xl text-gray-700 mt-3 cursor-pointer transition-all duration-300`}
                  >
                    {card.description}
                  </p>
                </div>
              </div>
            ))}
          </div>

          <p className="text-3xl mt-8 mb-6">
            Enterprise-grade security. Built-in compliance. Role-based access.
          </p>
          <br />
          <br />
          <div className="flex flex-col md:flex-row items-center  gap-5 ">
            <a
              href="https://meetings.hubspot.com/chrissybil/vero-learning"
              className="btn btn-secondary w-fit !text-lg !px-12 !py-6 hover:underline"
              target="_blank"
            >
              Book a live walkthrough <ExportedIcon />
            </a>
            <h2 className="text-3xl font-bold text-center md:text-left !leading-relaxed">
              Want to see how it works?
            </h2>
          </div>
        </div>
      </section>

      {/* How It Works Section  */}
      <section className=" py-16">
        <div className="container">
          <div className="text-center mb-10">
            <h2 className="text-3xl sm:text-4xl md:text-6xl !leading-snug mb-6">
              How It
              <span className="text-primary-500 font-bold"> Works</span>
            </h2>
            <p className="text-4xl">One platform. Three steps. Smarter decisions.</p>
          </div>

          {/* Cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
            {/* Step 1 */}
            <div className="relative bg-primary-100 rounded-[40px] p-8 md:p-4 flex flex-col items-center text-center lg:max-h-[470px]">
              <SurfaceIcon className="mb-5 w-full" />
              <h3 className="text-2xl font-semibold mb-3">Surface Hidden Potential</h3>
              <p className="text-lg">
                Layer pre-employment data—skills, competencies, and motivation signals—on top of
                your current intake.
              </p>
            </div>

            {/* Step 2 */}
            <div className="relative md:mt-[15%]">
              <img
                src={connectingLine}
                alt="connecting Line"
                className="relative -ml-10 hidden md:block"
              />
              <div className="bg-primary-100 rounded-[40px] p-8 md:p-6 flex flex-col items-center text-center lg:max-h-[470px]">
                <MatchIcon className="mb-5 w-full" />
                <h3 className="text-2xl font-semibold mb-3">Match + Recommend</h3>
                <p className="text-lg ">
                  Vero’s AI predicts job success and recommends where each candidate is likely to
                  thrive.
                </p>
              </div>
            </div>

            {/* Step 3 */}
            <div className="relative md:mt-[50%]">
              <img
                src={connectingLine}
                alt="connecting Line"
                className="relative -ml-10  hidden md:block"
              />
              <div className="bg-primary-100 rounded-[40px] p-8 md:p-6 flex flex-col items-center text-center lg:max-h-[470px]">
                <PlaceIcon className="mb-5 w-full" />
                <h3 className="text-2xl font-semibold mb-3">Place + Improve</h3>
                <p className="text-lg ">
                  After placement, Vero tracks outcomes and flags what to do next. Think: <br />{' '}
                  “Retrain this team in 90 days” <br /> or <br /> “Fast track this performer to team
                  lead.”
                </p>
              </div>
            </div>
          </div>
          <div className="text-center text-2xl mt-8">
            <p>Built for scale. Designed for privacy. Ready to integrate.</p>
          </div>
        </div>
      </section>

      {/* Curious how your team compares? section */}
      <section className="py-8 bg-green-200">
        <div className="container px-4">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-center md:text-left">
            <h2 className="text-3xl sm:text-3xl font-bold">Curious how your team compares?</h2>
            <a
              href="https://meetings.hubspot.com/chrissybil/vero-learning"
              className="btn btn-secondary !text-lg  !px-12 !py-6 hover:underline inline-flex items-center gap-2"
              target="_blank"
              rel="noopener noreferrer"
            >
              Let’s map it together <ExportedIcon />
            </a>
          </div>
        </div>
      </section>

      {/* Why Vero, Why Now? Section */}
      <section className="py-16">
        <div className="container px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
            {/* Left Content */}
            <div>
              <h2 className="text-4xl sm:text-5xl md:text-6xl lg:text-6xl font-light mb-4 !leading-tight">
                Why Vero,
                <span className="font-bold text-primary-500"> Why Now?</span>
              </h2>
              <p className="text-3xl sm:text-2xl !leading-loose mb-8">
                The future of hiring isn’t just faster—it’s fairer, smarter, and built on data that
                sees what resumes miss.
                <br />
                <br />
                AI has flooded hiring with automation—but very little insight. Most platforms
                reinforce old filters. Vero changes that.We help employers make decisions based on
                who someone can become, not just who they’ve been.
                <br />
                <br />
                If you’re hiring at scale, managing churn, or building long-term pipelines—you need
                more than a resume filter. You need a predictive system.
              </p>
              <a
                className="btn btn-secondary !px-12 !py-6 hover:underline inline-flex items-center gap-2"
                href="https://meetings.hubspot.com/chrissybil/vero-learning"
                target="_blank"
              >
                Let’s build smarter hiring. <ExportedIcon />
              </a>
            </div>

            {/* Right Content (Image) */}
            <div className="relative w-full">
              <img
                src={forEmp}
                alt="For Employers Who Look Beyond the Hire"
                className="w-full h-auto"
                loading="lazy" // Added lazy loading for better performance
              />
            </div>
          </div>
        </div>
      </section>

      {/* Who We Serve Best section */}
      <section className="bg-green-200 py-16">
        <div className="container max-w-6xl mx-auto px-4">
          <h2 className="text-3xl text-center lg:text-6xl mb-9 font-normal">
            Who We <span className="text-primary-500 font-bold">Serve Best</span>
          </h2>

          <p className="text-xl font-normal text-center  mx-auto">
            We help HR and staffing leaders identify who to interview, where to place them, and how
            to retain them—especially in high-churn sectors like retail, health care, logistics, and
            manufacturing.
          </p>

          <hr className="my-9 border-gray-300" />

          <p className="text-xl font-normal text-center  mx-auto">
            <strong>Best fit for:</strong> HR Directors, Talent Acquisition Leaders, People Strategy
            Execs, and staffing teams at scale.
            <br />
            <br />
            If you’re hiring in high-churn environments—or building long-term workforce pipelines—we
            help you reduce risk, boost retention, and unlock performance.
          </p>

          <hr className="my-9 border-gray-300" />

          <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-center md:text-left">
            <h3 className="text-2xl lg:text-3xl font-medium !leading-relaxed">
              Start with a 90-day rollout.
              <br /> Scale into multi-year transformation.
            </h3>

            <a
              href="/login"
              className="btn btn-secondary !text-lg  !px-12 !py-6"
              target="_blank"
              rel="noopener noreferrer"
            >
              Start Now <ExportedIcon />
            </a>
          </div>
        </div>
      </section>

      <section className="py-16">
        <div className="container">
          <h2 className="text-5xl text-center mb-8 !leading-normal">
            What Makes Vero Different
            <br />
            <span className="font-bold text-primary-500">Hiring Tools vs Vero Learning</span>
          </h2>
          <div className="overflow-x-auto">
            <table className="w-[99%] md:w-full lg:w-2/3 mx-auto border-collapse  md:table block border-b  rounded-2xl shadow-[0px_3px_8px_rgba(0,0,0,0.24)] ">
              {' '}
              <thead className="bg-primary-100 text-lg text-left md:table-header-group hidden">
                <tr>
                  <th className="p-4 text-left rounded-l-2xl whitespace-nowrap">Category</th>
                  <th className="p-4 text-left whitespace-nowrap">Most Hiring Tools</th>
                  <th className="p-4 text-left rounded-r-2xl whitespace-nowrap">Vero Learning</th>
                </tr>
              </thead>
              <tbody className="block md:table-row-group">
                {comparisonData.map((row, index) => (
                  <tr
                    key={index}
                    className="block md:table-row border-b md:border-0 mb-4 md:mb-0 rounded-lg shadow-[0px_4px_6px_rgba(0,0,0,0.16)] md:shadow-none"
                  >
                    <td
                      data-label="Category"
                      className="bg-primary-100 md:bg-transparent rounded-lg md:rounded-none p-4 md:text-xl font-medium md:font-bold block md:table-cell relative pl-[170px] md:pl-4 
                       before:content-[attr(data-label)] before:absolute before:left-4 before:top-1/2 
                       before:-translate-y-1/2 before:font-semibold before:text-base md:before:hidden"
                    >
                      {row.category}
                    </td>
                    <td
                      data-label="Most Hiring Tools"
                      className="border-b border-gray-200 md:border-none p-4 text-base md:text-lg block md:table-cell relative pl-[170px] md:pl-4 
                       before:content-[attr(data-label)] before:absolute before:left-4 before:top-1/2 
                       before:-translate-y-1/2 before:font-semibold before:text-base md:before:hidden"
                    >
                      {row.mostHiringTools}
                    </td>
                    <td
                      data-label="Vero Learning"
                      className="p-4 text-base md:text-lg block md:table-cell relative pl-[170px] md:pl-4 
                       before:content-[attr(data-label)] before:absolute before:left-4 before:top-1/2 
                       before:-translate-y-1/2 before:font-semibold before:text-base md:before:hidden"
                    >
                      {row.veroLearning}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <p className="text-2xl text-center mt-8 !leading-loose">
            Legacy platforms track applicants. Vero predicts long-term success.
          </p>
          <p className="text-2xl text-center !leading-loose">
            And we do it with data you already have plus insights no one else sees.
          </p>
          <div className="flex justify-center mt-6">
            <a
              href="https://meetings.hubspot.com/chrissybil/vero-learning"
              className="btn btn-secondary  !px-12 !py-6 justify-center"
              target="_blank"
              rel="noopener noreferrer"
            >
              Schedule a strategy session <ExportedIcon />
            </a>
          </div>
        </div>
      </section>

      {/* Proven Impact Section */}
      <section className="bg-primary-200 pt-16">
        <div className="container">
          <h2 className="text-5xl text-center">
            Proven <span className="text-primary-500 font-bold">Impact.</span>
          </h2>
          <TestimonialCarousel testimonials={testimonialData} />
        </div>
      </section>

      {/* #1 Vocational Section */}
      <VovationalPage imagePosition="right" />

      {/* Trusted by employers, cities, and changemakers shaping the future of work. */}
      <TrustedBrands />

      <ConnectForm
        header="Let’s build predictive hiring together"
        text="The future of hiring starts here. You’re not just filling roles - you’re building careers, teams, and systems that last. Vero helps you do that with intelligence, precision, and a long-term lens."
        buttonText="Book a conversation"
      />
      <NewFooter />
    </div>
  );
};
